import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Semanticpmpmvt7fldq2 as Semantic,
  HoverSemantic_getInstance2nvjr5vpt4xe8 as HoverSemantic_getInstance,
  DownSemantic_getInstance12o2om5g6786l as DownSemantic_getInstance,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from './AppColors.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { Constant5dc3leeorpdb as Constant } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/CornerRadii.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function AlphaSemantic$default$lambda($this$to, it) {
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, it.qb0_1.db2().fcz(0.6));
}
function AlphaSemantic$default$lambda_0($this$to, it) {
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, it.qb0_1.db2().fcz(0.5));
}
var AlphaSemanticClass;
function AlphaSemantic() {
  if (AlphaSemanticClass === VOID) {
    class $ extends Semantic() {
      static djr() {
        AlphaSemantic_instance = null;
        var $this = this.dd1('alpha');
        AlphaSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var newBack = theme.qb0_1.db2().fcz(0.5);
        var newFront = newBack.rcz().ad0_1 < 0.5 ? Companion_getInstance().taz_1 : Companion_getInstance().vaz_1;
        var tmp = HoverSemantic_getInstance();
        var tmp_0 = to(tmp, AlphaSemantic$default$lambda);
        var tmp_1 = DownSemantic_getInstance();
        var tmp0_derivations = mapOf([tmp_0, to(tmp_1, AlphaSemantic$default$lambda_0)]);
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, newFront, VOID, VOID, VOID, VOID, newBack, VOID, VOID, VOID, VOID, VOID, tmp0_derivations);
      }
      toString() {
        return 'AlphaSemantic';
      }
      hashCode() {
        return 1231773266;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AlphaSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'AlphaSemantic');
    AlphaSemanticClass = $;
  }
  return AlphaSemanticClass;
}
var AlphaSemantic_instance;
function AlphaSemantic_getInstance() {
  if (AlphaSemantic_instance === VOID)
    AlphaSemantic().djr();
  return AlphaSemantic_instance;
}
function get_alphaTheme(_this__u8e3s4) {
  return _this__u8e3s4.jbb(AlphaSemantic_getInstance());
}
function ImagePreviewSemantic$default$lambda($this$to, it) {
  var tmp0_background = AppColors_getInstance().hfz_1.yg9_1;
  var tmp1_foreground = Companion_getInstance().taz_1;
  var tmp2_outlineWidth = get_px(0);
  var tmp3_cornerRadii = new (Constant())(get_AppDimensions().rg2_1);
  var tmp = CardSemantic_getInstance();
  var tmp4_derivations = mapOf_0(to(tmp, ImagePreviewSemantic$default$lambda$lambda));
  return $this$to.jd1(it, VOID, VOID, VOID, tmp3_cornerRadii, VOID, VOID, tmp1_foreground, VOID, VOID, tmp2_outlineWidth, VOID, tmp0_background, VOID, VOID, VOID, VOID, VOID, tmp4_derivations);
}
function ImagePreviewSemantic$default$lambda$lambda($this$to, it) {
  return it.fb1(AlphaSemantic_getInstance());
}
var ImagePreviewSemanticClass;
function ImagePreviewSemantic() {
  if (ImagePreviewSemanticClass === VOID) {
    class $ extends Semantic() {
      static fjr() {
        ImagePreviewSemantic_instance = null;
        var $this = this.dd1('imgprv');
        ImagePreviewSemantic_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_background = AppColors_getInstance().hfz_1.bga_1;
        var tmp1_outlineWidth = get_px(0);
        var tmp = DialogSemantic_getInstance();
        var tmp2_derivations = mapOf_0(to(tmp, ImagePreviewSemantic$default$lambda));
        return this.jd1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_outlineWidth, VOID, tmp0_background, VOID, VOID, VOID, VOID, VOID, tmp2_derivations);
      }
      toString() {
        return 'ImagePreviewSemantic';
      }
      hashCode() {
        return -1542752763;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ImagePreviewSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ImagePreviewSemantic');
    ImagePreviewSemanticClass = $;
  }
  return ImagePreviewSemanticClass;
}
var ImagePreviewSemantic_instance;
function ImagePreviewSemantic_getInstance() {
  if (ImagePreviewSemantic_instance === VOID)
    ImagePreviewSemantic().fjr();
  return ImagePreviewSemantic_instance;
}
//region block: exports
export {
  get_alphaTheme as get_alphaThemewmx34wledr33,
  AlphaSemantic_getInstance as AlphaSemantic_getInstance2fqb49tln9c5i,
  ImagePreviewSemantic_getInstance as ImagePreviewSemantic_getInstance2vyufepdkqnqf,
};
//endregion

//# sourceMappingURL=files.mjs.map
